import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import GameMetric from './game-metric-model'
import {
  CreateGameMetricAsync,
  DeleteGameMetricAsync,
  LoadGameMetricsAsync,
} from './gameMetric-thunk'
const initialState: gameMetricSliceState = {
  gameMetric: [],
  selected_gameMetric: '',
  is_loading_gameMetric: false,
  is_creating_gameMetric: false,
  is_deleting_gameMetric: false,
}
export interface gameMetricSliceState {
  gameMetric: GameMetric[]
  selected_gameMetric?: string
  is_loading_gameMetric: boolean
  is_creating_gameMetric: boolean
  is_deleting_gameMetric: boolean
}
export const gameMetricSlice = createSlice({
  name: 'gameMetric',
  initialState,
  reducers: {
    setSelectedgameMetric: (state, action) => {
      state.selected_gameMetric = action.payload
    },
    clearStategameMetric: (state) => {
      state.gameMetric = []
      state.is_loading_gameMetric = false
      state.is_creating_gameMetric = false
      state.is_deleting_gameMetric = false
    },
    mergegameMetric: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_gameMetric = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.gameMetric = merge(state.gameMetric, payload) as any
        }
      }
    },

    add_gameMetric: (state, action) => {
      if (action.payload) {
        state.gameMetric = [...state.gameMetric, action.payload]
      }
    },
    set_gameMetric: (state, action) => {
      let { key, value, id } = action.payload
      state.gameMetric = state.gameMetric.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGameMetricsAsync.pending, (state) => {
      state.is_loading_gameMetric = true
    })
    builder.addCase(LoadGameMetricsAsync.fulfilled, (state, action) => {
      state.is_loading_gameMetric = false
      if (action.payload) {
        state.gameMetric = action.payload
      }
    })
    builder.addCase(LoadGameMetricsAsync.rejected, (state) => {
      state.is_loading_gameMetric = false
    })
    builder.addCase(CreateGameMetricAsync.pending, (state) => {
      state.is_creating_gameMetric = true
    })
    builder.addCase(CreateGameMetricAsync.fulfilled, (state) => {
      state.is_creating_gameMetric = false
    })
    builder.addCase(CreateGameMetricAsync.rejected, (state) => {
      state.is_creating_gameMetric = false
    })
    builder.addCase(DeleteGameMetricAsync.pending, (state) => {
      state.is_deleting_gameMetric = true
    })
    builder.addCase(DeleteGameMetricAsync.fulfilled, (state, action) => {
      state.is_deleting_gameMetric = false
      if (state.gameMetric) {
        state.gameMetric = state.gameMetric.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteGameMetricAsync.rejected, (state) => {
      state.is_deleting_gameMetric = false
    })
  },
})

export const {
  clearStategameMetric,
  setSelectedgameMetric,
  set_gameMetric,
  mergegameMetric,
  add_gameMetric,
} = gameMetricSlice.actions

export const get_gameMetric =
  (id?: string) =>
  (state: {
    gameMetric: {
      gameMetric: GameMetric[]
    }
  }): GameMetric | null => {
    let temp = state?.gameMetric?.gameMetric?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.gameMetric?.gameMetric[0] || null
  }
export const get_selected_gameMetric = (state: {
  gameMetric: gameMetricSliceState
}): GameMetric | null => {
  let id = state?.gameMetric?.selected_gameMetric
  let temp = state?.gameMetric?.gameMetric?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_gameMetric = (state: {
  gameMetric: {
    gameMetric: GameMetric[]
  }
}): GameMetric[] => {
  let temp = state?.gameMetric?.gameMetric
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_gameMetric_busy = (state: {
  gameMetric: gameMetricSliceState
}) => {
  return (
    state?.gameMetric.is_deleting_gameMetric ||
    state?.gameMetric.is_loading_gameMetric ||
    state?.gameMetric.is_creating_gameMetric
  )
}
export const is_deleting_gameMetric_busy = (state: {
  gameMetric: gameMetricSliceState
}) => {
  return state?.gameMetric.is_deleting_gameMetric
}
export const is_loading_gameMetric_busy = (state: {
  gameMetric: gameMetricSliceState
}) => {
  return state?.gameMetric.is_loading_gameMetric
}
export const is_creating_gameMetric_busy = (state: {
  gameMetric: gameMetricSliceState
}) => {
  return state?.gameMetric.is_creating_gameMetric
}

export default gameMetricSlice.reducer
